import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  ViewEncapsulation
} from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MediaMatcher } from '@angular/cdk/layout';
import { MenuItems } from '../../../shared/menu-items/menu-items';
import { roleSettings } from '../../../services/role/role-settings';
import { environment } from '../../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { AddDashboardComponent } from '../../../shared/component/add-dashboard/add-dashboard.component';
import { CommunicationService } from '../../../services/communication/communication.service';

/**
 * This is a sidebar component that reads the config file from /shared/menu-items/menu-items.ts and displays the side menus. It also uses the role setting (/services/role/role-settings.ts) to hide/show or lock the particular item from the menu.
 * 
 * Sidebar contains the following menus
 * 
 * Dashboard 
 * 
 * Patients
 * 
 * MyCareRewards 
 * 
 * MyCareInsights
 */
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent implements OnDestroy {
  public config: PerfectScrollbarConfigInterface = {};
  mobileQuery: MediaQueryList;
  sideBarSettings = roleSettings.superAdmin.sideMenu;
  logoUrl = environment.sidebarLogoUrl;
  private _mobileQueryListener: () => void;
  status = false;
  clickEvent() {
    this.status = !this.status;
  }

  subclickEvent() {
    this.status = true;
  }

  sideMenuItems: any = [];
  constructor(
    private dialog: MatDialog,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private communicationService: CommunicationService
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.addDynamicMenues();
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

/**
 * This function is used to add the dynamic menu item inside the side menu. It fetches the Queue boards from the firebase and binds those. 
 */
  addDynamicMenues() {
    this.communicationService.getBoards.subscribe(data => {
      this.sideMenuItems = this.menuItems.getMenuitem();
      const i = this.sideMenuItems.findIndex(y => y.state === 'dashboard');
      if (i !== -1) {
        const newRoutes = [];
         data.map(x => {
            newRoutes.push({ state: x.routeName, key: x.routeName, name: x.boardName, type: 'link' });
            this.sideBarSettings.dashboard.children[x.routeName] = {
              hide: false,
              disable: false,
              lock: false
            }
        })
        newRoutes.push({ state: 'add-dashboard', key: 'add-dashboard', name: 'Add Dashboard', type: 'popup' });
        this.sideMenuItems[i].children = newRoutes;
      }
    })
  }

  /**
   * 
   * This function is used to open the add dashboard popup, User can add a new dashboard to the system
   */
  openPopup(type) {
    this.dialog.open(AddDashboardComponent, {
      width: '450px',
      data: {
      }
    });
  }
}
